import { render, staticRenderFns } from "./InAddDragHandle.vue?vue&type=template&id=0b951e4c&"
import script from "./InAddDragHandle.vue?vue&type=script&lang=ts&"
export * from "./InAddDragHandle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports